import { Avatar, Button, Stack, Typography } from '@mui/material';
import { LightBlueX, WhiteTrashBin } from 'Images';
import { isDesktop } from 'react-device-detect';

interface IDeleteButtons {
  onClickNo: () => void;
  onClickYes: () => void;
  noLabel: string;
  yesLabel: string;
}

export const DeleteButtons = ({
  onClickNo,
  onClickYes,
  noLabel,
  yesLabel,
}: IDeleteButtons) => (
  <Stack direction='row' justifyContent='center' gap='40px'>
    <Button
      variant='outlined'
      sx={{
        bgcolor: 'white',
        width: '234px',
        alignItems: 'center',
        gap: '4px',
        p: isDesktop ? '12px 0px' : '8px 0px',
        height: isDesktop ? undefined : '36px',
      }}
      onClick={onClickNo}
    >
      <Avatar alt='' src={LightBlueX} sx={{ width: '20px', height: '20px' }} />
      <Typography variant='body4'>{noLabel}</Typography>
    </Button>
    <Button
      variant='contained'
      sx={{
        bgcolor: '#3A6EEC',
        width: '234px',
        alignItems: 'center',
        gap: '4px',
        p: isDesktop ? '12px 0px' : '8px 0px',
        height: isDesktop ? undefined : '36px',
      }}
      onClick={onClickYes}
    >
      <Avatar
        alt=''
        src={WhiteTrashBin}
        sx={{ width: '20px', height: '20px' }}
      />
      <Typography variant='body4'>{yesLabel}</Typography>
    </Button>
  </Stack>
);
